import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import "./CookieConsent.css";

const COOKIE_CONSENT_KEY = "darpha_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Pequeño delay para no bloquear el render inicial
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({
        accepted: true,
        date: new Date().toISOString(),
      }),
    );
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({
        accepted: false,
        date: new Date().toISOString(),
      }),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <div className="cookie-consent-icon">
            <FontAwesomeIcon icon={faShieldHalved} />
          </div>
          <div className="cookie-consent-text">
            <h3>Uso de Cookies y Almacenamiento Local</h3>
            <p>
              Esta aplicación utiliza cookies y almacenamiento local para
              gestionar tu sesión, recordar tus preferencias y mejorar tu
              experiencia. No compartimos tus datos con terceros.
            </p>
            <button
              className="cookie-consent-link"
              onClick={() =>
                navigate("/privacy-policy&terms-of-service", {
                  state: { tab: "privacy" },
                })
              }
            >
              Ver Política de Privacidad
            </button>
          </div>
        </div>
        <div className="cookie-consent-actions">
          <button
            className="cookie-consent-btn cookie-consent-btn-decline"
            onClick={handleDecline}
          >
            Rechazar
          </button>
          <button
            className="cookie-consent-btn cookie-consent-btn-accept"
            onClick={handleAccept}
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
